import Tooltip from 'components/Tooltip';
import { noop } from 'lodash/fp';
import React, { FC } from 'react';
import { FieldError } from 'react-hook-form';
import { InfoIconGreen } from 'static';

import {
  StyledBlock,
  StyledCheckbox,
  StyledErrorMessage,
  StyledInfoIcon,
  StyledInput,
} from './styled';

interface CheckBoxProps {
  label?: string | JSX.Element;
  disabled?: boolean;
  name?: string;
  isSelected: boolean;
  error?: FieldError;
  width?: string;
  indeterminate?: boolean;
  labelStyles?: { [key: string]: any };
  zoom?: number;
  checkBoxWidth?: string;
  register?: () => void;
  reduceMargin?: boolean;
  onClick?: (e?: any) => void;
  onChange?: (e: any) => void;
  toolkitText?: string;
}

const CheckBox: FC<CheckBoxProps> = ({
  label = '',
  disabled = false,
  register = noop,
  name,
  error,
  isSelected,
  onChange = noop,
  onClick,
  width,
  indeterminate,
  labelStyles,
  reduceMargin = false,
  zoom = 1,
  checkBoxWidth,
  toolkitText,
}) => (
  <StyledBlock
    className={disabled && 'disabled'}
    width={width}
    labelStyles={labelStyles}
    zoom={zoom}
    onClick={onClick}
    reduceMargin={reduceMargin}
  >
    <StyledInput
      ref={register}
      name={name}
      type="checkbox"
      checked={isSelected}
      disabled={disabled}
      onChange={onChange}
      indeterminate={indeterminate}
      zoom={zoom}
      checkBoxWidth={checkBoxWidth}
    />
    <StyledCheckbox zoom={zoom} size={checkBoxWidth} />
    {label}
    {toolkitText && (
      <Tooltip
        text={toolkitText}
        isVisible
        tooltipStyle={{
          fontSize: 12,
          maxWidth: 240,
          whiteSpace: 'pre-wrap',
          lineBreak: 'normal',
        }}
        position="top-center"
        opacity="1"
      >
        <StyledInfoIcon>
          <InfoIconGreen width={13} height={13} />
        </StyledInfoIcon>
      </Tooltip>
    )}
    {error && (
      <StyledErrorMessage zoom={zoom}>{error.message}</StyledErrorMessage>
    )}
  </StyledBlock>
);

export default CheckBox;
